export class PaginationControls {
    /**
     * @param {Object} options
     * @param {HTMLElement} options.target - Container element to render into
     * @param {number} options.currentPage - Current page number (1-based)
     * @param {number} options.totalPages - Total pages
     * @param {Function} options.onPageChange - Callback(newPage)
     */
    static render({ target, currentPage, totalPages, onPageChange, isCompact = false }) {
        if (!target) {
            console.error('[Pagination] Target not found!');
            return;
        }

        console.log('[Pagination] Rendering. Current:', currentPage, 'Total:', totalPages);

        target.innerHTML = '';
        // [DEBUG] Temporarily allow 1 page rendering to verify UI existence
        // if (totalPages <= 1) return;

        const wrapper = document.createElement('div');
        // [MODIFIED] Compact Mode Support
        const paddingClass = isCompact ? 'py-2 mt-2' : 'py-6 mt-4';
        const gapClass = isCompact ? 'gap-1' : 'gap-2';
        wrapper.className = `flex justify-center items-center ${gapClass} ${paddingClass} border-t border-gray-100`;

        // Helper to create button
        const createBtn = (content, onClick, disabled = false, active = false) => {
            const btn = document.createElement('button');
            const sizeClass = isCompact ? 'w-7 h-7 text-xs' : 'w-8 h-8 text-sm';

            if (active) {
                btn.className = `${sizeClass} flex items-center justify-center rounded-full font-bold transition-all bg-indigo-50 text-indigo-600`;
            } else {
                btn.className = `${sizeClass} flex items-center justify-center rounded-full font-bold transition-all text-gray-500 hover:bg-gray-50 hover:text-gray-900 disabled:opacity-30 disabled:cursor-not-allowed`;
            }
            btn.innerHTML = content;
            if (disabled) btn.disabled = true;
            else btn.onclick = onClick;
            return btn;
        };

        // Prev Button
        wrapper.appendChild(createBtn(
            '<span class="material-symbols-outlined text-sm">chevron_left</span>',
            () => onPageChange(currentPage - 1),
            currentPage === 1
        ));

        // Pages
        for (let i = 1; i <= totalPages; i++) {
            // Logic: Show 1, Last, and Current +/- 2
            if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) {
                wrapper.appendChild(createBtn(
                    i,
                    () => onPageChange(i),
                    false,
                    i === currentPage
                ));
            } else if (i === currentPage - 3 || i === currentPage + 3) {
                // Ellipsis
                const span = document.createElement('span');
                span.className = 'text-gray-300 text-xs';
                span.innerText = '...';
                wrapper.appendChild(span);
            }
        }

        // Next Button
        wrapper.appendChild(createBtn(
            '<span class="material-symbols-outlined text-sm">chevron_right</span>',
            () => onPageChange(currentPage + 1),
            currentPage === totalPages
        ));

        target.appendChild(wrapper);
    }
}
